import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import { LazyLoadImage } from "react-lazy-load-image-component";
import Img from "../../images/locationgcc/qa/mobileapp.webp";

function Ecommerceshopify () {
  return (
    <div
      className="ecommerce_app_design p-100"
      style={{ background: "#F6F6F6" }}
    >
      <Container>
        <Row>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <div className="banenr_content">
              <h2>Other Concerns</h2>
              <p>
                Consider the challenges mentioned above are just the tip of the
                iceberg. Other than these, creating an app has many other
                decisions and challenges that you might face—for example;
                Marketing, distribution, market changes, scalability, etc.
              </p>
            </div>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Get Your App Project Delivered On Time
            </Link>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-xl-1 offset-lg-1"
          >
            <LazyLoadImage
              src={Img}
              effect="blur"
              alt="TekRevol"
              className="img-fluid"
            />
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default Ecommerceshopify;
